import en from "./locales/en.js";
import enGB from "./locales/en-GB.js";
export { en, enGB };
